<template>
  <div class="page-block">
    <div class="page-block__inner">
      <div class="form-wrap form-wrap--profile u-no-margin-top">
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic"><span class="req">＊</span>アーティスト活動歴:
            </label>
            <i
              class="sp-tooltip-icon">
            </i>
          </div>
          <div
            class="form-item form-item--change-btn">
            {{ submitData.artistActivityHistory }}
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic">
              <span class="req">＊</span>デビュー作ですか?:
            </label>
            <i
              class="sp-tooltip-icon">
            </i>
          </div>
          <div
            class="form-item form-item--change-btn">
            {{ submitData.isDebut }}
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic"><span class="req">＊</span>CDリリース予定:
            </label>
            <i
              class="sp-tooltip-icon">
            </i>
          </div>
          <div
            class="form-item form-item--change-btn">
            {{ submitData.cdReleaseSchedule }}
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic"><span class="req">＊</span>キャッチコピー:
            </label>
            <i
              class="sp-tooltip-icon">
            </i>
          </div>
          <div class="double-label-container">
            <div class="form-label">
              <label
                class="control-label">日本語:
              </label>
            </div>
            <div
              class="form-item form-item--change-btn margin-l margin-y">
              {{ submitData.catchCopyJapanese }}
            </div>
            <div class="form-label">
              <label
                class="control-label">英語:
              </label>
            </div>
            <div
              class="form-item form-item--change-btn margin-l margin-y">
              {{ submitData.catchCopyEnglish }}
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic"><span class="req">＊</span>リリース概要 :
            </label>
            <i
              class="sp-tooltip-icon">
            </i>
          </div>
          <div class="double-label-container">
            <div class="form-label">
              <label
                class="control-label">日本語:
              </label>
            </div>
            <div
              class="form-item form-item--change-btn margin-l margin-y">
              {{ submitData.releaseOverviewJapanese }}
            </div>
            <div class="form-label">
              <label
                class="control-label">英語:
              </label>
            </div>
            <div
              class="form-item form-item--change-btn margin-l margin-y">
              {{ submitData.releaseOverviewEnglish }}
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic">
              MV先行公開楽曲 :
            </label>
            <i
              class="sp-tooltip-icon">
            </i>
          </div>
          <div
            v-for="(item, index) in mvPrereleaseSong"
            :key="index"
            class="form-item form-item--change-btn">
            {{ item }}
          </div>
        </div>

        <!--  start snsInformation -->
        <div
          class="form-wrap"
          style="border-bottom:1px solid #dadada;">
          <div class="form-pad">
            <div class="form-label">
              <label class="control-label">
                ＊SNS情報 :
              </label>
            </div>
            <div class="profile-info">
              <div class="form-wrap form-wrap--profile u-no-margin-top">
                <div
                  slot="content"
                  class="content_block">
                  <div class="form-group js-tooltip">
                    <div class="form-label">
                      <label class="control-label">Official Site :
                      </label>
                    </div>
                    <div class="form-item">
                      {{ submitData.officialSite }}
                    </div>
                  </div>
                  <div class="form-group js-tooltip">
                    <div class="form-label">
                      <label class="control-label">Other :
                      </label>
                    </div>
                    <div class="form-item">
                      {{ submitData.otherSite }}
                    </div>
                  </div>
                  <div class="form-group js-tooltip">
                    <div class="form-label">
                      <label class="control-label">X</label>
                    </div>
                    <div class="form-item d-flex">
                      <div class="form-label d-flex flex-column align-baseline">
                        <label
                          class="control-label">アカウント名 :</label>
                        {{ snsInformation.twitter.accountId }}
                      </div>
                      <div class="form-label d-flex flex-column align-baseline">
                        <label
                          class="control-label">フォロワー数 :</label>
                        {{ snsInformation.twitter.follower }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group js-tooltip">
                    <div class="form-label">
                      <label class="control-label">Youtube</label>
                    </div>
                    <div class="form-item d-flex">
                      <div class="form-label d-flex flex-column align-baseline">
                        <label
                          class="control-label">アカウント名 :</label>
                        {{ snsInformation.youtube.accountId }}
                      </div>
                      <div class="form-label d-flex flex-column align-baseline">
                        <label
                          class="control-label">チャンネル登録者数 :</label>
                        {{ snsInformation.youtube.follower }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group js-tooltip">
                    <div class="form-label">
                      <label class="control-label">Instagram</label>
                    </div>
                    <div class="form-item d-flex">
                      <div class="form-label d-flex flex-column align-baseline">
                        <label
                          class="control-label">アカウント名 :</label>
                        {{ snsInformation.instagram.accountId }}
                      </div>
                      <div class="form-label d-flex flex-column align-baseline">
                        <label
                          class="control-label">フォロワー数 :</label>
                        {{ snsInformation.instagram.follower }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group js-tooltip">
                    <div class="form-label">
                      <label class="control-label">Soundcloud</label>
                    </div>
                    <div class="form-item d-flex">
                      <div class="form-label d-flex flex-column align-baseline">
                        <label
                          class="control-label">アカウント名 :</label>
                        {{ snsInformation.soundcloud.accountId }}
                      </div>
                      <div class="form-label d-flex flex-column align-baseline">
                        <label
                          class="control-label">フォロワー数 :</label>
                        {{ snsInformation.soundcloud.follower }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group js-tooltip">
                    <div class="form-label">
                      <label class="control-label">TikTok</label>
                    </div>
                    <div class="form-item d-flex">
                      <div class="form-label d-flex flex-column align-baseline">
                        <label
                          class="control-label">アカウント名 :</label>
                        {{ snsInformation.tiktok.accountId }}
                      </div>
                      <div class="form-label d-flex flex-column align-baseline">
                        <label
                          class="control-label">フォロワー数 :</label>
                        {{ snsInformation.tiktok.follower }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group js-tooltip">
                    <div class="form-label">
                      <label class="control-label">Facebook</label>
                    </div>
                    <div class="form-item d-flex">
                      <div class="form-label d-flex flex-column align-baseline">
                        <label
                          class="control-label">アカウント名 :</label>
                        {{ snsInformation.facebook.accountId }}
                      </div>
                      <div class="form-label d-flex flex-column align-baseline">
                        <label
                          class="control-label">フォロワー数 :</label>
                        {{ snsInformation.facebook.follower }}
                      </div>
                    </div>
                  </div>
                </div>
                <!--                </accordion>-->
              </div>
            </div>
          </div>
        </div>
        <!-- snsInformation end -->
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic">
              <span class="req">＊</span>アーティスト写真（正方形）
            </label>
            <i
              class="sp-tooltip-icon">
            </i>
          </div>
          <div class="release-jacket-area">
            <div
              class="release-jacket-area__pic">
              <img
                style="width: 240px; height: 240px;"
                :src="squareImageSrc" />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <label
              class="control-label"
              for="artist_name_domestic">
              <span class="req">＊</span>アーティスト写真（長方形）
            </label>
            <i
              class="sp-tooltip-icon">
            </i>
          </div>
          <div class="release-jacket-area">
            <div
              style=" padding-right: 38px;">
              <img
                style="width: 240px; height: auto;"
                :src="rectImageSrc" />
            </div>
          </div>
        </div>
        <!--        Promotional staRT-->
        <div class="form-wrap">
          <div class="form-pad">
            <label>宣伝用の資料等 </label>
            <div
              class="release-jacket-area"
              style="margin-top: 10px; padding-bottom: 20px;">
              <div
                v-for="(file, index) in submitData.promotionalMaterials"
                :key="index"
                class="uploaded-items">
                <p>
                  {{ file.name }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!--        PROMOTIONAL END-->
      </div>
      <div
        class="c-btn-wrap">
        <a
          class="c-btn c-btn--back c-btn--back-left"
          href="#"
          @click.prevent="onBackClickedHandle">
          <span>編集画面に戻る</span>
          <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
        </a>
        <a
          class="c-btn"
          href="#"
          @click.prevent="onNextClickedHandle">
          <span>サブミットを依頼する</span>
          <span class="c-btn__icon-arrow"></span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'SubmitConfirm',
  props: {
    submitData: {
      type: Object,
      required: true,
    },
    snsInformation: {
      type: Object,
      required: true,
    },
    mvPrereleaseSong: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      readonly: false,
      type: 'single',
      data: {
      },
      rectImageSrc: '',
      squareImageSrc: '',
      isOpen: false,

    }
  },
  mounted() {
    this.convertToBase64(this.submitData.squareFile)
      .then((base64) => {
        this.squareImageSrc = base64
      })
    this.convertToBase64(this.submitData.rectangleFile)
      .then((base64) => {
        this.rectImageSrc = base64
      })
  },
  methods: {
    onBackClickedHandle() {
      this.$emit('onReturn')
    },
    onNextClickedHandle() {
      this.$emit('onSubmit')
    },
    convertToBase64(file) {
      return new Promise((resolve, reject) => {
        if (file) {
          const reader = new FileReader()

          reader.onload = (e) => {
            resolve(e.target.result)
          }

          reader.onerror = (error) => {
            reject(error)
          }

          reader.readAsDataURL(file)
        } else {
          reject(new Error('No file provided.'))
        }
      })
    },
    accordionToggle() {
      this.isOpen = !this.isOpen
    },
  },
}
</script>

<style scoped>
.margin-l{
  margin-left:1rem;
}
.margin-y{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.double-label-container{
  display: flex;
  flex-direction: column;
  flex:1;
}
.uploaded-items {
  background: #e3e3e3;
  margin: 0 20px;
  padding: 4px 10px;
  border-radius: 6px;
  position: relative;
}
</style>
